module.exports = __webpack_public_path__ + "img/gaku_btn_01.1a3a14e8.png";